import { render } from "./LCASearchResult.vue?vue&type=template&id=5add96ec"
import script from "./LCASearchResult.vue?vue&type=script&lang=js"
export * from "./LCASearchResult.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__